import Vue from 'vue';
Vue.config.silent = true;
import Vuex from 'vuex';

Vue.use(Vuex);

import App from './App';
import Application from './Application'
import Landlord from './Landlord'
import Document from './Document'
import Prequalification from './Prequalification'
import Project from "../../dashboard/store/Project";

export default new Vuex.Store({
    modules: {
        App,
        Application,
        Landlord,
        Document,
        Prequalification,
        Project,
    }
})
